import HttpService from "./http-service";
import Documentation from "@/entities/documentation";
import AsyncPaginatedRequest from "./async-paginated-request";
import { LazyAsyncIter } from "@/iterators";
import { pageMapperBuilder, Paginated } from "@/pagination";

export default class DocumentationService extends HttpService {
  public async getDocumentation(
    documentationId: number
  ): Promise<Documentation> {
    const response = await this.httpClient.get<DocumentationDTO>(
      `/documentations/${documentationId}`
    );
    return documentationFromDTO(response.data);
  }

  public getAllDocumentations(
    searchName?: string
  ): AsyncIterator<Paginated<Documentation>> {
    const params: Record<string, string> = {};
    if (searchName != undefined) {
      params.search_name = searchName;
    }
    const asyncReq = new AsyncPaginatedRequest<DocumentationDTO>(
      "get",
      "documentations",
      params,
      undefined,
      this.httpClient
    )[Symbol.asyncIterator]();
    return new LazyAsyncIter(asyncReq).map(
      pageMapperBuilder(documentationFromDTO)
    );
  }

  public async getExplanation(
    documentationId: number
  ): Promise<ExplanationDTO | null> {
    const { data } = await this.httpClient.get<ExplanationDTO | "">(
      `/documentations/${documentationId}/explanations`
    );
    return data == "" ? null : data;
  }

  public async updateDocument(document: UpdateDocumentation): Promise<void> {
    await this.httpClient.put(`/documentations/${document.id}`, document);
  }

  //  public async updateExplanation(
  //    explanation: Explanation & {images: number[]}
  //  ) {
  //    const response = await this.httpClient.put(
  //      `/explanations/${explanation.id}`,
  //      explanation
  //    );
  //    return response;
  //  }

  //  public async insertExplanation(
  //    explanation: Omit<Explanation, "id"> & {images: number[]}
  //  ) {
  //    const response = await this.httpClient.post(
  //      `/documentations/${explanation.documentation_id}/explanations`,
  //      explanation
  //    );
  //    return response;
  //  }
}
export interface UpdateDocumentation {
  id: number;
  name: string;
  description: string;
  explanation?: string;
  images?: number[];
}
export interface DocumentationDTO {
  id: number;
  name: string;
  description: string;
  recurrence: string;
  index: number;
  documentation_group_id: string;
}

export interface ExplanationDTO {
  id: number;
  body: string;
  documentation_id: number;
}

export function documentationFromDTO(dto: DocumentationDTO): Documentation {
  return new Documentation({
    id: dto.id,
    name: dto.name,
    description: dto.description,
    index: dto.index,
    group: null,
  });
}
